import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@ui-propulsion/react-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Link from 'next/link';
import styles from './fullBgCard.module.scss';
import GradientMask from '../gradientMask/gradientMask';
import handleCTAClick from '../../services/helpers/handleCTAClick';
import useWindowDimensions from '../../hooks/useWindowDimensions';

function FullBGCard({
  bgImageUrl = '',
  headLine = '',
  description = '',
  cta = {
    label: '',
    link: '',
  },
  contentPostion = 'right',
  hideBgImage = false,
  config = {
    gradientMask: null,
  },
  fullBgImage = true,
  desktopImage,
  mobileImage,
}) {
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < 401) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);

  let textPositionStyle = {};

  if (contentPostion === 'left') {
    textPositionStyle = {
      textAlign: 'left',
    };
  } else if (contentPostion === 'right') {
    textPositionStyle = {
      textAlign: 'right',
    };
  } else {
    textPositionStyle = {
      textAlign: 'center',
    };
  }
  const propsGradientMask = config?.gradientMask ?? null;

  return fullBgImage ? (
    <Grid className={styles.wrapper}>
      {propsGradientMask && <GradientMask {...propsGradientMask} />}
      <div
        className={`${styles.wrapperBackground} ${
          hideBgImage ? styles.wrapperBackgroundHidden : ''
        }`}
        style={{
          backgroundImage: `url('${bgImageUrl}')`,
        }}
      />
      {headLine && description && (
        <Grid
          className={`${styles.contentWrapper} ${
            contentPostion !== 'left'
              ? styles.contentWrapperRight
              : styles.contentWrapperLeft
          } ${hideBgImage ? styles.contentWrapperFull : ''}`}
        >
          <h4 className={styles.cardTitle}>{headLine}</h4>
          <div className={styles.cardContent}>{parse(description)}</div>
          {cta ? (
            <div className={styles.cardLink}>
              <Button
                color="red"
                href={cta.link}
                className={styles.submitBtn}
                onClick={(e) => handleCTAClick(e, cta)}
              >
                {cta.label}
              </Button>
            </div>
          ) : null}
        </Grid>
      )}
    </Grid>
  ) : (
    <Grid className={styles.imageBlock}>
      {!isMobile && desktopImage && (
        <div className={styles.desktopImage} style={textPositionStyle}>
          {desktopImage.link ? (
            <Link href={desktopImage?.link}>
              <img
                src={desktopImage.image.url}
                alt={desktopImage.image.alt}
                loading="lazy"
              />
            </Link>
          ) : (
            <img
              src={desktopImage.image.url}
              alt={desktopImage.image.alt}
              loading="lazy"
            />
          )}
        </div>
      )}
      {isMobile && mobileImage && (
        <div className={styles.mobileImage}>
          {mobileImage.link ? (
            <Link href={mobileImage?.link}>
              <img
                src={mobileImage.image.url}
                alt={mobileImage.image.alt}
                loading="lazy"
              />
            </Link>
          ) : (
            <img
              src={mobileImage.image.url}
              alt={mobileImage.image.alt}
              loading="lazy"
            />
          )}
        </div>
      )}
    </Grid>
  );
}

FullBGCard.propTypes = {
  bgImageUrl: PropTypes.string,
  headLine: PropTypes.string,
  description: PropTypes.string,
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  contentPostion: PropTypes.string,
  hideBgImage: PropTypes.bool,
  fullBgImage: PropTypes.bool,
  config: PropTypes.any,
  desktopImage: PropTypes.shape({
    link: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
    }),
  }),
  mobileImage: PropTypes.shape({
    link: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
    }),
  }),
};

export default FullBGCard;
